import React from 'react'

const WorkspaceContext = React.createContext({})

export { WorkspaceContext }
